"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShinyProxyStatus = exports.AppViewType = exports.AppInstanceType = exports.AppType = exports.StartAppType = exports.AppStatus = exports.ShinnyProxyAppStatus = exports.ContainerStatus = void 0;
var ContainerStatus;
(function (ContainerStatus) {
    ContainerStatus["Active"] = "active";
    ContainerStatus["Creating"] = "creating";
    ContainerStatus["NotDeployed"] = "not_deployed";
})(ContainerStatus || (exports.ContainerStatus = ContainerStatus = {}));
var ShinnyProxyAppStatus;
(function (ShinnyProxyAppStatus) {
    ShinnyProxyAppStatus["Up"] = "Up";
    ShinnyProxyAppStatus["New"] = "New";
    ShinnyProxyAppStatus["Terminated"] = "Terminated";
})(ShinnyProxyAppStatus || (exports.ShinnyProxyAppStatus = ShinnyProxyAppStatus = {}));
var AppStatus;
(function (AppStatus) {
    AppStatus["Initiated"] = "initiated";
    AppStatus["Downloading"] = "downloading";
    AppStatus["Pending"] = "pending";
    AppStatus["Running"] = "running";
    AppStatus["Creating"] = "creating";
    AppStatus["Terminated"] = "terminated";
})(AppStatus || (exports.AppStatus = AppStatus = {}));
var StartAppType;
(function (StartAppType) {
    StartAppType["Report"] = "report";
    StartAppType["Standalone"] = "standalone";
})(StartAppType || (exports.StartAppType = StartAppType = {}));
var AppType;
(function (AppType) {
    AppType["docker"] = "docker";
    AppType["public"] = "public";
})(AppType || (exports.AppType = AppType = {}));
var AppInstanceType;
(function (AppInstanceType) {
    AppInstanceType["report"] = "report";
    AppInstanceType["standalone"] = "standalone";
})(AppInstanceType || (exports.AppInstanceType = AppInstanceType = {}));
var AppViewType;
(function (AppViewType) {
    AppViewType[AppViewType["MyApps"] = 1] = "MyApps";
    AppViewType[AppViewType["SharedWithMe"] = 2] = "SharedWithMe";
    AppViewType[AppViewType["AdminView"] = 3] = "AdminView";
    AppViewType[AppViewType["NonAdminDefault"] = 4] = "NonAdminDefault";
})(AppViewType || (exports.AppViewType = AppViewType = {}));
var ShinyProxyStatus;
(function (ShinyProxyStatus) {
    ShinyProxyStatus["Success"] = "success";
    ShinyProxyStatus["Fail"] = "fail";
    ShinyProxyStatus["Error"] = "error";
})(ShinyProxyStatus || (exports.ShinyProxyStatus = ShinyProxyStatus = {}));
